// Brand + shared content for Aldebaran (fictional TON DAO).
export const BRAND = "Aldebaran";
export const TOKEN = "DREAM";
export const WALLET = "EQDrjaLahZqM1xN4z9pVm3R0fK8sN1pQzV7cD9eA2bT0nDR";
export const EMAIL = "hello@aldebaran.xyz";
export const APP_URL = "/instructions";

export const NAV = [
  { name: "About", path: "/about" },
  { name: "Documents", path: "/documents" },
  { name: "Audit", path: "/audit" },
  { name: "Instructions", path: "/instructions" },
];

// name + href + react-icons key (resolved in <Socials/>)
export const SOCIALS = [
  { name: "Telegram", href: "https://t.me/", icon: "telegram" },
  { name: "X", href: "https://x.com/", icon: "x" },
  { name: "Discord", href: "https://discord.com/", icon: "discord" },
  { name: "GitHub", href: "https://github.com/", icon: "github" },
  { name: "Mirror", href: "https://mirror.xyz/", icon: "mirror" },
  { name: "Medium", href: "https://medium.com/", icon: "medium" },
  { name: "YouTube", href: "https://youtube.com/", icon: "youtube" },
  { name: "Reddit", href: "https://reddit.com/", icon: "reddit" },
  { name: "TON Society", href: "https://society.ton.org/", icon: "ton" },
];

// Believable TON-ecosystem partners (rendered as uniform white wordmarks,
// not baked PNG logos, so they read consistently on the dark theme).
export const PARTNERS = [
  "TON Foundation",
  "Tonkeeper",
  "STON.fi",
  "DeDust",
  "Getgems",
  "TON Society",
  "Tonana",
  "EVAA",
  "Storm Trade",
  "Tonstakers",
];
